import Cookies from 'js-cookie';

export const setAccessToken = (accessToken) =>
  Cookies.set('accessToken', accessToken, {
    expires: parseInt(process.env.REACT_APP_COOKIE_EXPIRY_DAYS, 10),
  });

export const getAccessToken = () => Cookies.get('accessToken');
